import axios from "axios";
import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import leftArrow from "../../../assets/images/common/left-arrow.svg";
import cancelIcon from "../../../assets/images/editor/cancel.svg";
import uploadIcon from "../../../assets/images/notice/upload.svg";
import * as API_URL from "../../../constants/ApiUrl";
import * as QUERY from "../../../constants/query/Notice.query";
import * as Routes from "../../../constants/Routes";
import Popup from "../../common/popup/Popup";
import {PopupProps} from "../../common/popup/Popup.props";
import {InitialNoticeDto, NoticeDto} from "../dto/Notice.dto";
import TextEditor from "../textEditor/TextEditor";
import "./style.css";

export default function Write() {
    const [noticeDto, setNoticeDto] = useState<NoticeDto>(InitialNoticeDto);
    const [file, setFile] = useState<File | null>(null);
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const fileInputRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state !== null && location.state !== undefined) {
            axios.post(API_URL.GRAPHQL, {query: QUERY.GET(location.state.seq)})
                .then(response => {
                    const noticeDto = response.data.data.get;
                    noticeDto.seq = location.state.seq;
                    noticeDto.content = noticeDto.content.replace(/\\"/g, '"');

                    setNoticeDto(noticeDto);
                });
        }
    }, [location.state]);

    const handleBackButtonClick = () => {
        navigate(Routes.NOTICE, {replace: true});
    }

    const handleSubjectChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNoticeDto({
            ...noticeDto,
            title: event.target.value
        });
    };

    const handleContentChange = (content: string) => {
        setNoticeDto(prevState => ({
            ...prevState,
            content: content
        }));
    };

    const handleFileButtonClick = () => {
        if (fileInputRef.current) {
            const fileInput = fileInputRef.current as any as HTMLInputElement;
            fileInput.click();
        }
    };

    const handleFileInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFile(event.target.files!![0]);
    };

    const getAttachmentFileName = () => {
        if (file) {
            return file.name;
        }

        return noticeDto.attachmentFileName;
    }

    const handleFileInputClear = () => {
        setNoticeDto(prevState => ({
            ...prevState,
            attachmentFileName: "",
        }));

        if (fileInputRef.current) {
            const fileInput = fileInputRef.current as any as HTMLInputElement;
            fileInput.value = "";
            fileInput.files = null;

            setFile(null);
        }
    }

    const handleRegButtonClick = () => {
        let message = "";

        if (noticeDto.title.replace(/\s/g, "") === ""
            || noticeDto.content.replace(/<p>|<\/p>|\s|<br>/g, "") === "") {
            message = "제목 및 내용을 입력해 주세요.";
        } if (noticeDto.title.length > 100) {
            message = "제목은 100자 이하로 입력해 주세요.";
        }

        if (message !== "") {
            setPopupProps({
                subject: "공지사항 등록",
                message1: message,
                message2: null,
                buttonName: "확인",
                onConfirm: () => setPopupProps(null),
                useCloseButton: false,
                onClose: () => {}
            });

            return;
        }

        const formData = new FormData();

        formData.append("file", file? file : "");
        formData.append("noticeDto", JSON.stringify(noticeDto));

        axios.post(API_URL.NOTICE, formData, {headers: {"Content-Type": "multipart/form-data"}})
            .then(() => handleRegisterDone());
    };

    const handleRegisterDone = () => {
        setPopupProps({
            subject: "공지사항 등록",
            message1: "공지사항을 등록했습니다.",
            message2: null,
            buttonName: "확인",
            onConfirm: () => {
                setPopupProps(null);
                navigate(Routes.NOTICE);
            },
            useCloseButton: false,
            onClose: () => {}
        });
    }

    return (
        <>
            <div className="notice-add">
                <main className="wrapper">
                    <div className="notice-body">
                        <div className="title-wrapper">
                            <img src={leftArrow} alt="arrow" data-testid="backButton" onClick={handleBackButtonClick}/>
                            <div className="notice-title" data-testid="title">
                                { noticeDto.seq == null? "공지사항 추가" : "공지사항 수정" }
                            </div>
                        </div>
                        <div className="notice-add-title">
                            <div className="title">
                                제목
                            </div>
                            <input type="text"
                                   placeholder="제목을 입력해주세요"
                                   autoFocus={true}
                                   defaultValue={noticeDto?.title}
                                   data-testid="titleInput"
                                   onChange={handleSubjectChange}
                            />
                        </div>
                        <div className="notice-post-box">
                            <TextEditor content={noticeDto.content} onChange={handleContentChange}/>
                        </div>
                        <div className="post-button">
                            <div className="attachment-wrap">
                                <button className="menu-button" onClick={handleFileButtonClick}>
                                    <img src={uploadIcon} alt="icon"/>
                                    <div className="text">
                                        파일
                                    </div>
                                </button>
                                <input type="file"
                                       data-testid="fileInput"
                                       ref={fileInputRef}
                                       onChange={handleFileInput}/>
                                <div className="file-info">
                                    <span data-testid="fileName">
                                        {getAttachmentFileName()}
                                    </span>
                                    <img src={cancelIcon}
                                         data-testid="deleteFile"
                                         alt="icon"
                                         onClick={handleFileInputClear}/>
                                </div>
                            </div>
                            <button className="registration-button" data-testid="regButton" onClick={handleRegButtonClick}>
                                {noticeDto.seq == null? "등록하기" : "수정하기"}
                            </button>
                        </div>
                    </div>
                </main>
            </div>
            {
                popupProps && (
                    <Popup data={popupProps}/>
                )
            }
        </>
    );
}